import React from "react";
import { mainMenu } from "../../constants/data";

export default function Tabs(props) {
  const tabsRef = React.useRef([]);
  const [tabUnderlineWidth, setTabUnderlineWidth] = React.useState(0);
  const [tabUnderlineLeft, setTabUnderlineLeft] = React.useState(0);
  const [imageLoad, setImageLoad] = React.useState(false);

  React.useEffect(() => {
    const setTabPosition = () => {
      const currentTab = tabsRef.current[props.activeTabIndex];
      if (currentTab) {
        setTabUnderlineLeft(currentTab.offsetLeft);
        setTabUnderlineWidth(currentTab.clientWidth);
      }
    };

    setTabPosition();
  }, [props.activeTabIndex, imageLoad, props.showAllTabs]);

  // İlk 3 markayı görüntüle veya tüm markaları görüntüle
  const visibleTabs = props.showAllTabs ? mainMenu : mainMenu.slice(0, 3);

  return (
    <div className="flex items-center justify-center gap-8 relative h-13 transition-all duration-500 ease-in-out overflow-visible">
      <span
        className="absolute bottom-0 top-0 z-0 flex overflow-hidden rounded-full shadow-lg transition-all duration-300"
        style={{ left: tabUnderlineLeft, width: tabUnderlineWidth }}
      >
        <span className="h-full w-full rounded-xl bg-white opacity-80" />
      </span>
      <div className="flex items-center justify-center gap-8 relative">
        {mainMenu.map((tab, index) => {
          const isActive = props.activeTabIndex === tab.id;
          const isVisible = props.showAllTabs || index < 3;

          return (
            <button
              key={index}
              ref={(el) => (tabsRef.current[tab.id] = el)}
              className={`${
                isActive ? `` : `hover:text-neutral-300`
              } my-auto cursor-pointer select-none rounded-full w-auto px-4 text-center font-light text-white z-10 transition-all duration-500 ease-in-out ${
                isVisible
                  ? "opacity-100 relative visible"
                  : "opacity-0 invisible absolute"
              }`}
              style={{
                transitionDelay: isVisible ? `${index * 50}ms` : "0ms",
                transform: isVisible
                  ? "translateX(0) scale(1)"
                  : "translateX(-20px) scale(0.95)",
                position: isVisible ? "relative" : "absolute",
                left: isVisible ? "auto" : "-9999px",
              }}
              onClick={() => props.setActiveTabIndex(tab.id)}
            >
              <img
                src={`https://proj-assets.onedio.com/sunum/${tab.link}.svg`}
                onLoad={() => setImageLoad(true)}
                className="transition-transform duration-300"
              />
            </button>
          );
        })}
      </div>

      <button
        className={`my-auto cursor-pointer select-none rounded-full px-4 py-2 text-center text-base font-bold text-[#2D3140] z-10 flex items-center gap-2 transition-all duration-500 ease-in-out`}
        style={{
          opacity: props.showAllTabs ? 0 : 1,
          visibility: props.showAllTabs ? "hidden" : "visible",
          position: props.showAllTabs ? "absolute" : "relative",
          left: props.showAllTabs ? "-9999px" : "auto",
          transform: props.showAllTabs
            ? "translateX(20px) scale(0.95)"
            : "translateX(0) scale(1)",
        }}
        onClick={() => props.setShowAllTabs(true)}
      >
        <span>Diğer Markalarımız</span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="#2D3140"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button
        className={`my-auto cursor-pointer select-none rounded-full w-auto px-4 py-2 text-center font-light text-white z-10 transition-all duration-500 ease-in-out hover:bg-white hover:bg-opacity-10`}
        style={{
          opacity: props.showAllTabs ? 1 : 0,
          visibility: props.showAllTabs ? "visible" : "hidden",
          position: props.showAllTabs ? "relative" : "absolute",
          left: props.showAllTabs ? "auto" : "-9999px",
          transform: props.showAllTabs
            ? "translateX(0) scale(1)"
            : "translateX(20px) scale(0.95)",
        }}
        onClick={() => props.setShowAllTabs(false)}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 15l-6-6-6 6"
            stroke="#2D3140"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
}
